import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
const STAGE_API = "https://notregrandbleu.herokuapp.com/stage/";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" })
};
@Injectable({
  providedIn: 'root'
})
export class StageService {

  public Afficherstage(): Observable<any> {
    return this.http.get(STAGE_API , httpOptions);
  }

  addstage(stage): Observable<any> {
    return this.http.post(STAGE_API + "addStage", stage ,httpOptions );
  }
  deletestage(id): Observable<any> {
    return this.http.get(STAGE_API + "supprimer/"+ id ,httpOptions );
  }
  modify(stage):Observable<any>
  {
    return this.http.put(STAGE_API+ "modifier" ,  stage , httpOptions );
  }

  constructor(private http: HttpClient) { }
}
